export const theme = {
  colors: {
    headerBg: 'var(--color-header-bg)',
    headerText: 'var(--color-header-text)',
    headerTextMuted: 'var(--color-header-text-muted)',
    bg: 'var(--color-bg)',
    bgSubtle: 'var(--color-bg-subtle)',
    bgInset: 'var(--color-bg-inset)',
    border: 'var(--color-border)',
    borderMuted: 'var(--color-border-muted)',
    text: 'var(--color-text)',
    textMuted: 'var(--color-text-muted)',
    textSubtle: 'var(--color-text-subtle)',
    link: 'var(--color-link)',
    linkHover: 'var(--color-link-hover)',
    accent: 'var(--color-accent)',
    accentSoft: 'var(--color-accent-soft)',
    btnPrimary: 'var(--color-btn-primary)',
    btnPrimaryHover: 'var(--color-btn-primary-hover)',
    btnPrimaryBorder: 'var(--color-btn-primary-border)',
    btnDefault: 'var(--color-btn-default)',
    btnDefaultHover: 'var(--color-btn-default-hover)',
    tagBg: 'var(--color-tag-bg)',
    tagText: 'var(--color-tag-text)',
    topicBg: 'var(--color-topic-bg)',
    topicText: 'var(--color-topic-text)',
    avatarBg: 'var(--color-avatar-bg)',
    avatarBorder: 'var(--color-avatar-border)',
    tabActive: 'var(--color-tab-active)'
  },
  raw: {
    light: {
      headerBg: '#f6f8fa',
      headerText: '#24292f',
      headerTextMuted: '#57606a',
      bg: '#ffffff',
      bgSubtle: '#f6f8fa',
      bgInset: '#f6f8fa',
      border: '#d0d7de',
      borderMuted: '#d8dee4',
      text: '#1f2328',
      textMuted: '#656d76',
      textSubtle: '#6e7781',
      link: '#0969da',
      linkHover: '#054da7',
      accent: '#0969da',
      accentSoft: '#ddf4ff',
      btnPrimary: '#1f883d',
      btnPrimaryHover: '#1a7f37',
      btnPrimaryBorder: 'rgba(27, 31, 36, 0.15)',
      btnDefault: '#f6f8fa',
      btnDefaultHover: '#eef1f4',
      tagBg: '#ddf4ff',
      tagText: '#0969da',
      topicBg: '#eaeef2',
      topicText: '#1f2328',
      avatarBg: '#ffffff',
      avatarBorder: '#d0d7de',
      tabActive: '#fd8c73'
    },
    dark: {
      headerBg: '#010409',
      headerText: '#f0f6fc',
      headerTextMuted: '#9198a1',
      bg: '#0d1117',
      bgSubtle: '#161b22',
      bgInset: '#010409',
      border: '#30363d',
      borderMuted: '#21262d',
      text: '#e6edf3',
      textMuted: '#8b949e',
      textSubtle: '#6e7681',
      link: '#4493f8',
      linkHover: '#58a6ff',
      accent: '#4493f8',
      accentSoft: 'rgba(56, 139, 253, 0.15)',
      btnPrimary: '#238636',
      btnPrimaryHover: '#2ea043',
      btnPrimaryBorder: 'rgba(240, 246, 252, 0.1)',
      btnDefault: '#21262d',
      btnDefaultHover: '#30363d',
      tagBg: 'rgba(56, 139, 253, 0.15)',
      tagText: '#4493f8',
      topicBg: '#21262d',
      topicText: '#e6edf3',
      avatarBg: '#161b22',
      avatarBorder: '#30363d',
      tabActive: '#f78166'
    }
  },
  fonts: {
    body:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", Helvetica, Arial, sans-serif',
    mono:
      'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace'
  },
  shadows: {
    sm: 'none',
    md: 'none',
    lg: 'none'
  },
  radius: {
    sm: '6px',
    md: '6px',
    lg: '6px',
    xl: '6px',
    full: '9999px'
  },
  maxWidth: '1012px',
  sectionPadding: '32px'
};
